
export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://192.168.0.5:8000/api' : 'https://support.aswaq-libya.ly/api';

// const domain = window.location.origin;
// export const BASE_API_URL = `${domain}/api`;

export const DEFAULT_EMAIL: string = "info@aswaq-libya.ly"

export const RECAPTCHA_PUBLIC_KEY: string = process.env.NODE_ENV === 'development' ? '6LcIaiMqAAAAABdXey08VmWcJ_utt3C5ZzdNrVGx' : '6LfNuWIsAAAAAPQriz9fPiJKtj7eyYwfq0Hj7B1f';

export const COMPANY_NAME: {
    [key: string]: string;
} = {
    ar: "شركة اسواق ليبيا  | الدعم الفني",
    en: "Aswaq Libya | Technical Support"
}
